export enum LogChoices {
    AUTO = "none",
    BASE10 = "log10",
    // BASE2 = "log2",
    // NATURAL = "ln",
};